import arrayUtilities from '../../utilities/arrayUtilities';
import stringHelpers from '../../utilities/stringHelpers';
import { toDateString } from '../../utilities/dateUtilities';

// Reusable checkbox table for selecting breach or site attachments to append to a letter.
// isSite=false: breach style (File Name/Subject + Timestamp, supports emails).
// isSite=true: site style (File Name + Date + Valid From/To).
// imagesOnly=true: only image attachments are listed (documents/emails are hidden).
export default function AttachmentSelectTable(props) {
    const {
        label,
        isSite,
        attachments,
        selected,
        setSelected,
        isSelectAllChecked,
        setIsSelectAllChecked,
        idPrefix,
        imagesOnly,
    } = props;

    const visibleAttachments = imagesOnly ? (attachments ?? []).filter(item => item.isImage) : attachments;

    if (arrayUtilities.isNullOrEmpty(visibleAttachments)) {
        return null;
    }

    return (
        <>
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row mb-3">
                <label class="col-sm-3 col-form-label col-form-label-sm">{ label }</label>
                <div className='col-sm-9'>
                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                        <thead className="bg-200 text-900">
                            <tr>
                                <td>
                                    <input type="checkbox" checked={ isSelectAllChecked } id={ `select-all-${ idPrefix }` } onChange={
                                        event => arrayUtilities.handleSelectAll(event, isSelectAllChecked, setIsSelectAllChecked, () => setSelected([]), () => setSelected(visibleAttachments.map(item => item.id))) } />
                                </td>
                                <th>{ isSite ? 'File Name' : 'File Name/Subject' }</th>
                                <th className="text-center">{ isSite ? 'Date' : 'Timestamp' }</th>
                                { isSite && <th className="text-center">Valid From</th> }
                                { isSite && <th className="text-center">Valid To</th> }
                                <th className={ isSite ? 'thumbnail-col' : '' }>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                visibleAttachments.map((item) => <tr key={ item.id }>
                                    <td><input type="checkbox" checked={ selected.includes(item.id) } id={ `select-${ idPrefix }-${ item.id }` }
                                        onChange={ event => arrayUtilities.handleListSelection(event.target.checked, item, setSelected, selected, visibleAttachments, isSelectAllChecked, setIsSelectAllChecked) } /></td>
                                    <td>
                                        {
                                            item.isEmail
                                                ? <>{ item.subject }</>
                                                : <a href={ item.url } target="_blank"><h6 className="mb-0">{ item.filename }</h6></a>
                                        }
                                    </td>
                                    <td className="text-center">{ !stringHelpers.isNullOrEmpty(item.timestamp) && <>{ toDateString(item.timestamp) }</> }</td>
                                    { isSite && <td className="text-center">{ !stringHelpers.isNullOrEmpty(item.validFrom) && <>{ toDateString(item.validFrom) }</> }</td> }
                                    { isSite && <td className="text-center">{ !stringHelpers.isNullOrEmpty(item.validTo) && <>{ toDateString(item.validTo) }</> }</td> }
                                    <td className="thumbnail-col">
                                        { item.isImage && <img src={ item.url } className="attachment-thumb" /> }
                                        { !item.isImage && <>
                                            { item.isEmail && <div className="d-flex justify-content-center my-2"><i className='fa-3x fas fa-paper-plane'></i></div> }
                                            { item.contentType === "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="fas fa-3x fa-file-pdf"></i></div> }
                                            { item.contentType === "application/word.doc" && <div className="d-flex justify-content-center my-2"><i className="far fa-3x fa-file-word"></i></div> }
                                            { !item.isEmail && item.contentType !== "application/word.doc" && item.contentType !== "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-3x fa-file-alt"></i></div> }
                                        </> }
                                    </td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
